import {Icon20MessageOutline} from "@vkontakte/icons";
import bridge from "@vkontakte/vk-bridge";
import React, {useState} from "react";
import {createReferralLink} from "../../services/referrals";
import {useSnackbar} from "../../context/SnackbarContext";
import {buildReferralLink} from "../../utils/referralLink";

const referralCtaCopy = {
    tournament_card: {
        title: "Сыграйте вместе",
        text: "Когда друг сыграет первую игру по вашей ссылке, вы получите 150 монет",
        button: "Скопировать ссылку",
    },
    tournament_joined: {
        title: "Позовите друга в турнир",
        text: "Когда друг сыграет первую игру по вашей ссылке, вы получите 150 монет",
        button: "Скопировать ссылку",
    },
    game_finished: {
        title: "Позовите друга",
        text: "Когда друг сыграет первую игру по вашей ссылке, вы получите 150 монет",
        button: "Скопировать ссылку",
    },
};

// ReferralInviteCta показывает контекстный призыв скопировать реферальную ссылку.
export function ReferralInviteCta({source = "tournament_card", variant = "compact", className = ""}) {
    const {showSuccessSnackbar, showErrorSnackbar} = useSnackbar();
    const [isCopying, setIsCopying] = useState(false);
    const copy = referralCtaCopy[source] || referralCtaCopy.tournament_card;
    const isInline = variant === "inline";

    const handleCopy = () => {
        if (isCopying) {
            return;
        }

        setIsCopying(true);
        createReferralLink(source).then(resp => {
            const token = resp?.data?.response?.token;
            if (!token) {
                throw new Error("empty referral token");
            }

            const link = buildReferralLink(token);
            return copyText(link);
        }).then(() => {
            showSuccessSnackbar("Ссылка скопирована. Отправьте её другу");
        }).catch(err => {
            console.error("Referral link copy error:", err);
            showErrorSnackbar("Не удалось скопировать ссылку");
        }).finally(() => {
            setIsCopying(false);
        });
    };

    return (
        <div className={`${isInline ? "rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-left" : "mt-2 rounded-lg border border-gray-300 bg-gray-200 px-3 py-2 text-left"} ${className}`}>
            <div className="flex flex-col items-stretch gap-2 sm:flex-row sm:items-center sm:justify-between">
                <div className="min-w-0 flex-1">
                    <p className="text-xs font-semibold text-gray-900">{copy.title}</p>
                    <p className="text-[11px] leading-snug text-gray-700">{copy.text}</p>
                </div>
                <button
                    type="button"
                    className="inline-flex w-full shrink-0 items-center justify-center gap-1 rounded-lg border border-gray-400 bg-gray-100 px-2 py-1 text-xs font-semibold text-gray-900 disabled:opacity-60 sm:w-[164px]"
                    onClick={handleCopy}
                    disabled={isCopying}
                >
                    <Icon20MessageOutline width={16} height={16}/>
                    {isCopying ? "Копируем..." : copy.button}
                </button>
            </div>
        </div>
    );
}

function copyText(text) {
    return withTimeout(
        bridge.send("VKWebAppCopyText", {text}),
        2000,
    ).catch(() => copyTextFallback(text));
}

function copyTextFallback(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "readonly");
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.select();

    const copied = document.execCommand("copy");
    document.body.removeChild(textArea);
    if (copied) {
        return Promise.resolve();
    }

    if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
    }

    throw new Error("copy command failed");
}

function withTimeout(promise, timeoutMs) {
    return new Promise((resolve, reject) => {
        const timeoutID = setTimeout(() => reject(new Error("copy timeout")), timeoutMs);
        promise.then(value => {
            clearTimeout(timeoutID);
            resolve(value);
        }).catch(error => {
            clearTimeout(timeoutID);
            reject(error);
        });
    });
}
